import React from 'react';
import Modal from '@material-ui/core/Modal';
import { ModalHeader, ModalBody } from './style';
import { Button } from '../button';
import { View } from 'react-native';

const OpenFlowModal = (props) => {
  const {
    modalBody,
    footerButtonText,
    handleOnModalButtonClick,
    showFooter,
    showModal,
    setShowModal,
    modalHeading = '',
    modalSubHeading = '',
    modalWidth = 500,
    hideCloseIcon = false,
  } = props;

  return (
    <Modal
      open={showModal ? showModal : false}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
      }}
    >
      <div
        style={{
          width: modalWidth,
          maxWidth: '95vw',
          backgroundColor: '#FFFFFF',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          padding: '16px',
          outline: 'none',
          borderRadius: '16px',
          position: 'relative',
          color: '#111827',
          maxHeight: '85vh',
          overflowY: 'auto',
        }}
      >
        {!hideCloseIcon && (
          <span
            style={{
              position: 'absolute',
              right: 20,
              top: 20,
              fontWeight: 'bold',
              color: '#6C2BD9',
              cursor: 'pointer',
              fontSize: '18px',
            }}
            onClick={() => setShowModal(false)}
          >
            ✕
          </span>
        )}
        <ModalBody style={{ padding: 0 }}>
          {modalHeading ? <ModalHeader>{modalHeading}</ModalHeader> : null}
          {modalSubHeading ? <View style={{ fontSize: 16, fontWeight: '600', marginBottom: 12 }}>{modalSubHeading}</View> : null}
          {modalBody}
        </ModalBody>
        {showFooter && (
          <div className="modal-footer" style={{ border: 'none', marginTop: 16 }}>
            <Button
              type="stripe"
              style={{ color: '#FC4850', borderColor: '#FC4850' }}
              onClick={handleOnModalButtonClick}
              title={footerButtonText}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default OpenFlowModal;
